export default "__VITE_ASSET__Dm_y_D11__"